import Tooltip from 'antd/lib/tooltip';
import Typography from 'antd/lib/typography';
import * as React from 'react';
import { runwayColors } from '../styles/globalStyles';
import { ThunderboltFilled } from '@ant-design/icons';
import { dayjs } from '@/extendedDayjs';
import { DatetimeFormat } from '@/timeHelpers';
import { flatMap, groupBy, sortBy } from 'lodash';
import { AppMonitoringHealthMetric, IntegrationType } from '@/types';
import { displayNameForIntegrationType } from '@/helpers/integrationHelpers';

export const lastUpdatedLabel = (timestamp: string | undefined) =>
    timestamp ? `Last updated ${dayjs.utc(timestamp).local().format(DatetimeFormat.ShortMonthDateTime)}` : undefined;

export const renamedMetricTooltip = (
    customDisplayName: string | undefined,
    generatedTitle: string,
    isDisplayNameTruncated = false,
) =>
    customDisplayName ?
        isDisplayNameTruncated ? `${customDisplayName} (${generatedTitle})`
        :   generatedTitle
    :   undefined;

export const sortMonitoringMetricsForDisplay = (metrics: AppMonitoringHealthMetric[]): AppMonitoringHealthMetric[] => {
    const integrationGroupsByName = sortBy(
        Object.entries(groupBy(metrics, (metric) => metric.integrationId)),
        ([integrationId]) => displayNameForIntegrationType(integrationId as IntegrationType),
    );
    return flatMap(integrationGroupsByName, ([, metricsForIntegration]) =>
        metricsForIntegration.sort((a, b) => {
            if (a.eventName && b.eventName) {
                if (a.eventName === b.eventName) {
                    return a.type < b.type ? -1 : 1;
                }

                return a.eventName < b.eventName ? -1 : 1;
            } else {
                return a.type < b.type ? -1 : 1;
            }
        }),
    );
};

export const generateAutomationThunderboltIcon: (args: {
    isUsedForAutoAccelerate: boolean;
    isUsedForAutoHalt: boolean;
    prefix?: string;
}) => React.ReactNode = ({ isUsedForAutoAccelerate, isUsedForAutoHalt, prefix }) => {
    return (
        (isUsedForAutoAccelerate || isUsedForAutoHalt) && (
            <Tooltip
                title={() => {
                    if (isUsedForAutoAccelerate && isUsedForAutoHalt) {
                        return (
                            <Typography.Text
                                style={{
                                    color: 'white',
                                }}
                            >
                                {prefix} <strong>Release stable phased releases to 100% of users</strong> and{' '}
                                <strong>the Halt unstable phased releases</strong> automations.
                            </Typography.Text>
                        );
                    } else if (isUsedForAutoAccelerate) {
                        return (
                            <Typography.Text
                                style={{
                                    color: 'white',
                                }}
                            >
                                {prefix} <strong>Release stable phased releases to 100% of users</strong> automation.
                            </Typography.Text>
                        );
                    } else if (isUsedForAutoHalt) {
                        return (
                            <Typography.Text
                                style={{
                                    color: 'white',
                                }}
                            >
                                {prefix} <strong>Halt unstable phased releases</strong> automation.
                            </Typography.Text>
                        );
                    }

                    return null;
                }}
            >
                <ThunderboltFilled style={{ color: runwayColors.primary }} />
            </Tooltip>
        )
    );
};
